import { useLocale } from './i18n'
import { UUID, safeHtml, safeUntrustedHtml } from './utils'

export type PrevioCore = {
  useLocale: typeof useLocale
  UUID: typeof UUID
  safeHtml: typeof safeHtml
  safeUntrustedHtml: typeof safeUntrustedHtml
}

export const usePrevioCore = (): PrevioCore => {
  return {
    useLocale,
    UUID,
    safeHtml,
    safeUntrustedHtml,
  }
}

export { Locales } from './i18n/locale'
export { i18n, $t, useLocale, createLocaleManager } from './i18n'
export { ErrorBase } from './error/ErrorBase'
export { ApplicationError } from './error/ApplicationError'
export * from './http'
export * from './previoId'
export * from './async'
export * from './utils'
export { Clearable } from './models/Clearable'
export { DateTimeRange } from './models/DateTimeRange'
export type { Serializable } from './models/Serializable'
export { Money } from './models/Money'
export { Price } from './models/Price'
export * from './models/ActionHandle'
export { Form } from './models/Form'
export type { Point } from './types/Point'
export type { ICurrency } from './types/ICurrency'
export type { IMoney } from './types/IMoney'
export type { Base64 } from './types/Base64'
export type { DownloadableFile } from './types/FileTypes'
export type { GenericComponentInstance } from './types/GenericComponentInstance'
export { useField } from './composables/useField'
export { useLazyStore } from './composables/store/useLazyStore'
export { configureDayjs } from './plugins/dayjs'
export * from './filter'
